<div class="app bs-flex-row bs-align-items-center" style="justify-content: center;">
  <mat-card style="padding: 32px;">
    <mat-card-title class="logout-content-card">
      <p *ngFor="let contentRow of content" style="font-size: large;">
        {{ contentRow }}
      </p>
    </mat-card-title>
  </mat-card>
</div>